import React, { useCallback, useRef } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './LineItem.scss';

export const LineItem = (props) => {
    const { gameCode: code, player, winAmount, gameName, showSeparator } = props;
    const winnerRef = useRef();
    const translate = useComponentTranslations();

    const openGame = useCallback(() => {
        publicEventsAPIService.trigger('game:launch', { code, mode: 1, container: 'top-winners' });

        // for accessibility: if game is opened in new window, focus stays on line and line doesn't run
        winnerRef.current?.blur();
    }, [code]);

    return (
        <>
            <AccessibilityElement
                inline={true}
                onClick={openGame}
                elementRef={winnerRef}
                className={style.topWinner}
                aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${gameName}`}
            >
                <span className={style.justWon}>{`${player} ${translate('justWon')} `}</span>
                <span className={style.winAmount}>{winAmount}</span>
                <span>{` ${translate('inGame')} ${gameName}`}</span>
            </AccessibilityElement>
            {showSeparator && (
                <span className={style.separator}>
                    {translate('lineView.separator')}
                </span>
            )}
        </>
    );
};
